import useTooltip from "../../../hooks/useTooltip";

type ActorInfoArgs = {
  url: string;
  displayName?: string;
  display_name?: string;
  detection_profile_field?: string;
  is_external?: boolean;
};

export default function ActorInfo({
  url,
  displayName,
  display_name,
  detection_profile_field,
  is_external = false,
}: ActorInfoArgs) {
  const tooltipRef = useTooltip<HTMLSpanElement>();

  return url ? (
    <a
      className="member-link activity-actor font-semibold"
      href={url}
      title={displayName || display_name}
    >
      {displayName || display_name}
      {detection_profile_field && ` (${detection_profile_field})`}
      {is_external && ` (${I18n.t("js.external_member.badge")})`}
    </a>
  ) : (
    <span
      ref={tooltipRef}
      className="member-link activity-actor font-semibold"
      title={I18n.t("js.memberships.profile_deleted_tooltip")}
    >
      {displayName}
    </span>
  );
}
